export const ignoreFirstArg = fn => (...args) => fn && fn(...args.slice(1));

export const propSwitcher = (firstReturn, restReturn) => {
    let firstCall = true;
    return () => {
        if (firstCall) {
            firstCall = false;
            return firstReturn;
        }
        return restReturn;
    }
};

export const invokeOnce = fn => {
    let invoked = false;
    let result = undefined;
    return (...args) => {
        if (!invoked) {
            invoked = true;
            result = fn(...args);
        }
        return result;
    }
};
